(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/circle-graph/assets/javascripts/views/circle-graph.js') >= 0) return;  svs.modules.push('/components/sport/circle-graph/assets/javascripts/views/circle-graph.js'); 
'use strict';

(function(Backbone, _, svs) {
  svs = svs || {};
  svs.sport = svs.sport || {};
  svs.sport.circle_graph = svs.sport.circle_graph || {};
  svs.sport.circle_graph.views = svs.sport.circle_graph.views || {};

  svs.sport.circle_graph.views.CircleGraph = Backbone.View.extend({
    tagName: 'div',
    className: 'align-center',
    width: 400,
    height: 400,
    doOnce: true,
    SPORT_HOCKEY: 'sport-hockey',
    SPORT_SOCCER: 'sport-soccer',
    POWER_PLAY: 'power-play',
    initialize: function(options) {
      this.options = options;
      this.id = options.id;

      if (this.options.width) this.width = this.options.width;

      if (this.options.height) this.height = this.options.height;
    },
    update: function(options) {
      this.options = options;
      this.render();
    },
    setModel: function() {},
    render: function() {
      this.createCircleChart(
        this.options.homeTeam,
        this.options.awayTeam,
        this.options.percentage,
        this.width,
        this.height,
        this.options.graphType
      );
    },
    onClose: function() {},
    pixelRation: function() {
      var id = this.id !== undefined ? this.id : 'circleChart';
      this.canvas = $('#' + id)[0];
      if (!this.canvas) {
        return null;
      }
      var context = this.canvas.getContext('2d'),
        dpr = window.devicePixelRatio || 1,
        bsr =
          context.webkitBackingStorePixelRatio ||
          context.mozBackingStorePixelRatio ||
          context.msBackingStorePixelRatio ||
          context.oBackingStorePixelRatio ||
          context.backingStorePixelRatio ||
          1;
      return dpr / bsr;
    },
    setCanvasDimension: function(context, w, h, ratio) {
      this.canvas.width = (w - 200) * ratio;
      this.canvas.height = (h - 200) * ratio;
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
    },
    createCircleChart: function(
      homeTeam,
      awayTeam,
      percentageValue,
      width,
      height,
      graphType
    ) {
      var id = this.id !== undefined ? this.id : 'circleChart';
      this.canvas = $('#' + id)[0];

      if (!this.canvas) {
        return true;
      }
      var context = this.canvas.getContext('2d');

      var ratio = Math.min(5, this.pixelRation()),
        w = width,
        h = height;

      this.doOnce = true;
      this.colors = ['#7d7d80', '#ffffff', '#323233', '#000000'];

      var biggestVal = 0;
      if (!isNaN(parseFloat(percentageValue))) biggestVal = percentageValue;
      else biggestVal = homeTeam;

      var goalDegree = 360 * (biggestVal / 100);

      this.data = [
        361, 
        goalDegree === 360 ? goalDegree - 1 : goalDegree,
        361, 
        361
      ];

      var i = 1;
      this.goalAngle = this.data[i];
      this.currentAngle = 0;
      this.homeTeamGoalVal = this.options.homeTeam;
      this.awayTeamGoalVal = this.options.awayTeam;
      this.percentageValue = this.options.percentageValue;
      this.playAnimation = this.options.playAnimation;
      this.homeTeamCurrent = 0;
      this.awayTeamCurrent = 0;
      this.graphType = graphType;

      this.animate(context, w, h, ratio);
      this.animate(context, w, h, ratio);
    },
    animate: function(context, w, h, ratio) {
      this.homeTeamCurrent = this.homeTeamGoalVal;
      this.awayTeamCurrent = this.awayTeamGoalVal;
      this.currentAngle = this.goalAngle;

      if (this.doOnce) {
        this.doOnce = false;
        this.setCanvasDimension(context, w, h, ratio);
        this.setTextLabels(
          this.homeTeamCurrent,
          this.awayTeamCurrent,
          context,
          this.graphType
        );
      }

      var i = 0;
      if (this.graphType === this.SPORT_SOCCER) {
        if (this.currentAngle > 0) {
          this.drawSegment(
            this.canvas,
            context,
            i,
            360 - this.currentAngle - 18,
            this.colors[i],
            100,
            ratio,
            true,
            false,
            279
          );
        }
      } else if (this.graphType === this.SPORT_HOCKEY) {
        if (this.currentAngle > 0) {
          this.drawSegment(
            this.canvas,
            context,
            i,
            360 - this.currentAngle - 16,
            this.colors[i],
            100,
            ratio,
            true,
            false,
            278
          );
        }
      } else {
        this.drawSegment(
          this.canvas,
          context,
          i,
          this.data[i],
          this.colors[i],
          100,
          ratio,
          false
        );
      }

      i = 1;
      if (this.graphType === this.SPORT_SOCCER) {
        if (this.currentAngle > 0) {
          this.drawSegment(
            this.canvas,
            context,
            i,
            360 - this.currentAngle + 18,
            this.colors[i],
            100,
            ratio,
            true,
            true,
            261
          );
        }
      } else if (this.graphType === this.SPORT_HOCKEY) {
        if (this.currentAngle > 0) {
          this.drawSegment(
            this.canvas,
            context,
            i,
            360 - this.currentAngle + 16,
            this.colors[i],
            100,
            ratio,
            true,
            true,
            262
          );
        }
      } else {
        this.drawSegment(
          this.canvas,
          context,
          i,
          360 - this.currentAngle,
          this.colors[i],
          100,
          ratio,
          true,
          true
        );
      }

      i = 2;
      if (this.graphType === this.SPORT_HOCKEY) {
        this.drawSegment(
          this.canvas,
          context,
          i,
          this.data[i],
          this.colors[i],
          76,
          ratio,
          false
        );
      } else {
        this.drawSegment(
          this.canvas,
          context,
          i,
          this.data[i],
          this.colors[i],
          74,
          ratio,
          false
        );
      }

      if (
        this.graphType === this.SPORT_HOCKEY ||
        this.graphType === this.POWER_PLAY
      ) {
        i = 3;
        if (this.graphType === this.SPORT_HOCKEY) {
          this.drawSegment(
            this.canvas,
            context,
            i,
            this.data[i],
            this.colors[i],
            69,
            ratio,
            false
          );
        } else {
          this.drawSegment(
            this.canvas,
            context,
            i,
            this.data[i],
            this.colors[i],
            49,
            ratio,
            false
          );
        }
      }
      this.setTextLabels(
        this.homeTeamCurrent,
        this.awayTeamCurrent,
        context,
        this.graphType
      );
    },
    setTextLabels: function(homeTeamVal, awayTeamVal, context, graphType) {
      var homeVal = Math.round(homeTeamVal);
      var awayVal = Math.round(awayTeamVal);

      if (graphType === this.SPORT_HOCKEY) {
        this.drawCanvasLabelHockey(context, homeVal, awayVal);
      } else if (graphType === this.POWER_PLAY) {
        this.drawCanvasLabel(context, homeVal, awayVal, true);
      } else if (graphType === this.SPORT_SOCCER) {
        this.drawHtmlLabel(homeVal, awayVal, true);
      }
    },
    drawCanvasLabelHockey: function(context, homeVal, awayVal) {
      var padding = 14;
      var posX = 202 / 2;

      context.font = 'bold 39px Platform';
      context.textAlign = 'right';
      context.fillStyle = '#ffffff';
      context.fillText(homeVal, posX - padding, 116);

      this.drawLine(context, '#4b4b4d', 67, posX, 67);

      context.font = 'bold 39px Platform';
      context.textAlign = 'left';
      context.fillStyle = '#6a6a6a';
      context.fillText(awayVal, posX + padding, 116);
    },
    drawCanvasLabel: function(
      context,
      homeVal,
      awayVal,
      displayPercentageSign
    ) {
      var txt = homeVal + (displayPercentageSign ? '%' : '');
      var totalWidth = context.measureText(txt).width;
      var homeValWidth = context.measureText(homeVal).width;
      var posX = 100 - (totalWidth + 5) / 2;

      if (displayPercentageSign) {
        posX = 100 - (totalWidth - 11) / 2;
      }

      context.fillStyle = '#ffffff';
      context.font = 'bold 28px Platform';
      context.textAlign = 'left';
      context.fillText(homeVal, posX, 110);
      context.save();

      if (displayPercentageSign) {
        posX = posX + homeValWidth;
        context.fillStyle = '#ffffff';
        context.font = '20px Platform';
        context.fillText('%', posX, 110);
        context.save();
      }
    },
    drawHtmlLabel: function(homeVal, awayVal, displayPercentageSign) {
      var homeLabel = '.circle-graph .home-label';
      var awayLabel = '.circle-graph .away-label';
      if (displayPercentageSign) {
        $(homeLabel).html(homeVal + '%');
        $(awayLabel).html(awayVal + '%');
      } else {
        $(homeLabel).html(homeVal);
        $(awayLabel).html(awayVal);
      }
    },
    drawLine: function(context, color, height, xoffset, yoffset) {
      context.beginPath();
      context.strokeStyle = color;
      context.lineWidth = 2;
      context.moveTo(xoffset, 0 + yoffset);
      context.lineTo(xoffset, height + yoffset);
      context.stroke();
      context.closePath();
    },
    drawSegment: function(
      canvas,
      context,
      i,
      size,
      color,
      radius,
      ratio,
      drawBeginingAndEnd,
      counterClockwise,
      nStartAngle
    ) {
      var self = this;
      context.save();
      var centerX = Math.floor(canvas.width / (2 * ratio));
      var centerY = Math.floor(canvas.height / (2 * ratio));

      if (!nStartAngle) nStartAngle = 270;

      var startingAngle = self.degreesToRadians(nStartAngle);
      var arcSize = self.degreesToRadians(size);
      var endingAngle = startingAngle + arcSize;

      context.beginPath();
      context.moveTo(centerX, centerY);
      context.arc(
        centerX,
        centerY,
        radius,
        startingAngle,
        endingAngle,
        counterClockwise
      );
      context.closePath();

      context.fillStyle = color;
      context.fill();
      context.restore();

      if (drawBeginingAndEnd) {
        context.beginPath();

        size = 13;
        if (this.graphType === this.SPORT_HOCKEY) {
          size = 12;
        }

        var radiusx = radius - size;
        var radiusy = radius - size;

        var xcircle = centerX;
        var ycircle = centerY;

        var startPointY = ycircle + radiusy * Math.sin(startingAngle);
        var startPointX = xcircle + radiusx * Math.cos(startingAngle);
        context.moveTo(startPointX, startPointY);
        context.arc(startPointX, startPointY, size, 0, 360, false);
        context.closePath();
        context.fillStyle = color;
        context.fill();
        context.restore();

        var endPointY = ycircle + radiusy * Math.sin(endingAngle);
        var endPointX = xcircle + radiusx * Math.cos(endingAngle);
        context.moveTo(endPointX, endPointY);
        context.arc(endPointX, endPointY, size, 0, 360, false);
        context.closePath();
        context.fillStyle = color;
        context.fill();
        context.restore();
      }
    },
    degreesToRadians: function(degrees) {
      return (degrees * Math.PI) / 180;
    }
  });
})(Backbone, _, svs);

 })(window);